import React from 'react';
import { Link } from 'react-router-dom';
import { storeLabels } from '../../lib/appLinks';
import { IS_PROD, BUILD_SHA } from '../../lib/env';
import styles from './Footer.module.css';

const Footer: React.FC = () => {
  const store = storeLabels();
  return (
    <footer className={styles.footer} role="contentinfo">
      <div className={styles.container}>
        <div className={styles.footerGrid}>
          <div className={styles.brand}>
            <div className={styles.logoRow}>
              <img
                src="/muse-logo.png"
                alt=""
                width={28}
                height={28}
                className={styles.logoImage}
                aria-hidden="true"
              />
              <span className={styles.logoText}>Muse</span>
            </div>
            <p className={styles.brandDescription}>
              The app we wanted on our own shoots: a pose library that works
              without signal, bookings with proper shot lists, and client
              galleries that feel like an occasion.
            </p>
          </div>
          <div className={styles.footerSection}>
            <h2 id="footer-product">Product</h2>
            <nav aria-labelledby="footer-product">
              <div className={styles.footerLinks}>
                <a href="/#library" className={styles.footerLink}>
                  The pose library
                </a>
                <a href="/#workflow" className={styles.footerLink}>
                  The workflow
                </a>
                <a href="/#galleries" className={styles.footerLink}>
                  Client galleries
                </a>
                <a href="/#faq" className={styles.footerLink}>
                  FAQ
                </a>
                <Link to="/guide" className={styles.footerLink}>
                  Getting started
                </Link>
                <Link to="/tutorials" className={styles.footerLink}>
                  Tutorials
                </Link>
              </div>
            </nav>
          </div>
          <div className={styles.footerSection}>
            <h2 id="footer-download">Get the app</h2>
            <nav aria-labelledby="footer-download">
              <div className={styles.footerLinks}>
                {store.interactive && store.apple.href ? (
                  <>
                    <a href={store.apple.href} className={styles.footerLink}>
                      {store.apple.verb} {store.apple.name}
                    </a>
                    <a
                      href={store.play.href ?? '/#get-the-app'}
                      className={styles.footerLink}
                    >
                      {store.play.verb} {store.play.name}
                    </a>
                  </>
                ) : (
                  <a href="/#get-the-app" className={styles.footerLink}>
                    Coming soon — iOS &amp; Android
                  </a>
                )}
              </div>
            </nav>
          </div>
          <div className={styles.footerSection}>
            <h2 id="footer-company">Company</h2>
            <nav aria-labelledby="footer-company">
              <div className={styles.footerLinks}>
                <a
                  href="mailto:support@musephoto.app"
                  className={styles.footerLink}
                >
                  Contact
                </a>
                <Link to="/privacy" className={styles.footerLink}>
                  Privacy Policy
                </Link>
                <Link to="/terms" className={styles.footerLink}>
                  Terms of Service
                </Link>
                <Link to="/guidelines" className={styles.footerLink}>
                  Community Guidelines
                </Link>
                <Link to="/copyright" className={styles.footerLink}>
                  Copyright
                </Link>
                <Link to="/legal" className={styles.footerLink}>
                  Legal &amp; Policies
                </Link>
                <Link to="/delete-account" className={styles.footerLink}>
                  Delete Account
                </Link>
              </div>
            </nav>
          </div>
        </div>
        <hr className={styles.divider} />
        <div className={styles.footerBottom}>
          <p className={styles.copyright}>
            &copy; {new Date().getFullYear()} Muse Productions Inc.
          </p>
          {/* Non-prod build stamp — UAT/preview only. Same tracked-caps
              tertiary register as the copyright line (no banner, no accent:
              colour is never the only signal, and amber is reserved for
              glyphs — DESIGN.md). aria-label hands a screen reader words, not
              a spelled-out hash. Never rendered in the prod bundle. */}
          {!IS_PROD && (
            <p
              className={styles.envStamp}
              aria-label={`Environment: UAT${
                BUILD_SHA ? `, build ${BUILD_SHA}` : ''
              }`}
            >
              {BUILD_SHA ? `UAT · ${BUILD_SHA}` : 'UAT'}
            </p>
          )}
          <p className={styles.trademark}>
            Apple, the Apple logo and App Store are trademarks of Apple Inc.,
            registered in the U.S. and other countries. Google Play and the
            Google Play logo are trademarks of Google LLC.
          </p>
          <div className={styles.bottomLinks}>
            <Link to="/privacy" className={styles.bottomLink}>
              Privacy
            </Link>
            <Link to="/terms" className={styles.bottomLink}>
              Terms
            </Link>
            <Link to="/security" className={styles.bottomLink}>
              Security
            </Link>
            <a
              href="mailto:support@musephoto.app"
              className={styles.bottomLink}
            >
              Support
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
